import { render, staticRenderFns } from "./description-container.vue?vue&type=template&id=ac4ab886"
import script from "./description-container.vue?vue&type=script&lang=ts"
export * from "./description-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac4ab886')) {
      api.createRecord('ac4ab886', component.options)
    } else {
      api.reload('ac4ab886', component.options)
    }
    module.hot.accept("./description-container.vue?vue&type=template&id=ac4ab886", function () {
      api.rerender('ac4ab886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/description/description-container.vue"
export default component.exports